<template>
    <Layout>
      <PageHeader :title="title" :items="items" />
  
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="mb-2 float-end">
                <b-button v-b-modal.new-item size="sm" variant="primary"><i class="mdi mdi-plus"></i> New Doctor </b-button>
              </div>
              <div class="clearfix"></div>
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                    <label class="d-inline-flex align-items-center">
                      Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <b-table
                  :items="Items"
                  :fields="Fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="Filtered"
                  :busy="IsBusy"
                >
                <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(photo)="data">
                  <img :src="getImage(data.item.photo)" height="50" alt="Doctor's Photo" />
                  </template>
                <template #cell(category)="data">
                 {{ data.item.speciality.name }}
                </template>
               <template #cell(addedby)="data">
                  {{ data.item.addedby.username }}
                </template>
                <template #cell(actions)="data">
                  <div class="btn-group">
                  <b-button @click="edit(data.item.id,data.item.name,data.item.location,data.item.category,data.item.phone,data.item.bio)" type="button" class="btn-sm btn" variant="primary" v-b-modal.edit> <i class="mdi mdi-square-edit-outline"></i> </b-button>
                  <b-button @click="remove(data.item.id,data.item.name)" type="button" class="btn-sm btn" variant="danger"  v-b-modal.delete> <i class="mdi mdi-trash-can"></i> </b-button>
                  </div>
                </template>
                </b-table>
              </div>
              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <b-modal id="new-item" centered title="New Doctor " title-class="font-18" hide-footer>
          <form @submit.prevent="addItem">
              <div class="form-group mb-2">
              <label> Name</label>
              <input v-model="name" type="text" class="form-control" />
              <label> Location</label>
              <input v-model="location" type="text" class="form-control" />
              <label> Phone Number</label>
              <input v-model="phone" type="number" v-mask="'##########'" class="form-control" />
              <label>Specialisation</label>
              <b-form-select v-model="category" required :options="specialties" class="mb-3 form-control" value-field="id" text-field="name"></b-form-select>
             <label>Profile Bio</label>
             <input type="text" v-model="bio" class="form-control"/>
              <label>Photo</label> 
              <input type="file" @change="handleFileUpload" class="form-control" />
              </div>
              <div class="form-group d-flex justify-content-end">
                  <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('new-item')" >Close</b-button>
                  <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
              </div>
          </form>
      </b-modal>
  
      <b-modal id="edit-item" centered title="Edit Doctor " title-class="font-14" hide-footer>
          <form @submit.prevent="editItem">
              <div class="form-group mb-2">
              <input v-model="id" type="hidden">
             <label> Name</label>
              <input v-model="name" type="text" class="form-control" />
              <label> Location</label>
              <input v-model="location" type="text" class="form-control" />
              <label>  Phone Number</label>
              <input v-model="phone" type="text" v-mask="'##########'" class="form-control" />
              <label>Specialisation</label>
              <b-form-select v-model="category" required :options="specialties" class="mb-3 form-control" value-field="id" text-field="name"></b-form-select>
              <label>Profile Bio</label>
             <input type="text" v-model="bio" class="form-control"/>
              <!-- <label>Photo</label> 
              <input  type="file" @change="handleFileUpload" class="form-control" /> -->
            </div>
              <div class="form-group d-flex justify-content-end">
                  <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('edit-item')" >Close</b-button>
                  <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
              </div>
          </form>
      </b-modal>
  
      <b-modal id="delete-item" centered title="Delete Doctor Speciality" title-class="font-18" hide-footer>
          <form @submit.prevent="removeItem">
              <input v-model="id" type="hidden">
                Are you sure you want to delete Doctor : <b>{{ name }}</b> ?
              <div class="form-group d-flex justify-content-end">
                  <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('delete-item')" >Close</b-button>
                  <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> YES</b-button>
              </div>
          </form>
      </b-modal>
  
    </Layout>
  </template>
  
  <script>
  import axios from "axios";
  import Layout from "../../layouts/main";
  import PageHeader from "@/components/page-header";
  import appConfig from "@/app.config";
  import { specialtiesMethods, specialtiesComputed} from "@/state/helpers";
  // import { specialtiesMethods, specialtiesComputed,specialisationMethods, specialisationComputed } from "@/state/helpers";
  import { doctorSpecialtyMethods, doctorSpecialtyComputed } from "@/state/helpers";
  
  export default {
    page: {
      title: "Doctor Specialisation",
      meta: [{ name: "description", content: appConfig.description,},],
    },
    components: {
      Layout,PageHeader

      // Layout,PageHeader,Multiselect
    },
    data() {
      return {
        title: "Doctors",
        items: [ {text: "Dashboard",to: "/",}, {text: "Doctors",active: true, }, ],
        TotalRows: 1,
        currentPage: 1,
        perPage: 10,
        Options: [10, 50, 100, 150, 200],
        filter: null,
        todoFilter: null,
        filterOn: [],
        sortDesc: true,
        isBusy: true,
        fields: [
            { key: 'index', label: '#', visible: true },
            { key: 'id', label: 'ID', visible: false },
            {key:  'photo', label: 'Photo', visible: true},
            { key: 'name', label: 'Name', visible: true },
            { key: 'location', label: 'Location', visible: true },
            { key: 'phone', label: 'Phone', visible: true },
            { key: 'category', label: 'Specialisation', visible: true },
            { key: 'bio', label: 'Profile Bio', visible: true },
            { key: 'actions', label: 'Actions', visible: true },
          ],
        id:'',
        name:'',
        category:[],
        speciality:'',
        location:'',
        phone:'',
        bio:'',
        photo:null,
      };
    },
    computed: {
      ...doctorSpecialtyComputed,
      ...specialtiesComputed,
      // ...specialisationComputed,
      List() { return this.doctorspecialty.length; },
      Fields() { return this.fields.filter(field => field.visible) },
      Items() { return this.doctorspecialty.map((d) => ({...d }))},
      IsBusy() { let a=false; if (this.doctorspecialty.length>0) { a=false;} else { a=true;} return a },
    },
    mounted() {
      this.fetchDoctorspecialty();
      this.fetchSpecialties();
      // this.fetchSpecialisation();
      this.TotalRows = this.doctorspecialty.length;
      this.isBusy=false;
    },
    methods: {
      ...doctorSpecialtyMethods,
      ...specialtiesMethods,
      // ...specialisationMethods,
      Filtered(filteredItems) {
        this.TotalRows = filteredItems.length;
        this.currentPage = 1;
      },
      getSpecialityName(id) {
      const speciality = this.specialties.find(s => s.id === id);
      return speciality ? speciality.name : 'Unknown';
    },
    handleFileUpload(event) {
    this.photo = event.target.files[0];
  },
  getImage(name){
let url = axios.defaults.baseURL;
let imagelink = (url).slice(0,-3)+"doctors/"+name;
return imagelink;
  },
  
      edit(id,name,location,category,phone,bio){
        this.id=id;
        this.name=name;
        this.location=location;
        this.phone=phone;
        this.category=category;
        this.bio=bio;
        this.$bvModal.show('edit-item')
      },
      remove(id,name){
        this.id=id;
        this.name=name;
        this.$bvModal.show('delete-item')
      },
      
      async addItem() { 
        let formData = new FormData();
        formData.append("name", this.name);
        formData.append("phone", this.phone);
        formData.append("location", this.location);
        formData.append('photo',this.photo);
        formData.append('bio',this.bio);
        // let categoryIds = '';
        // if (this.category) {
        //   for (let i = 0; i < this.category.length; i++) {
        //     categoryIds += this.category[i].id;
        //     if (i < this.category.length - 1) {
        //       categoryIds += ',';
        //     }
        //   }
        // }
        // formData.append("category", categoryIds);
        formData.append("category", this.category);
        let url = "/adddoctorspecialty";
        await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
            this.fetchDoctorspecialty();
            // this.fetchSpecialisation();
            this.$bvModal.hide('new-item');
            this.name="";
            this.phone="";
            this.location="";
            this.category="";
            this.photo=null;
            this.bio="";
        }
        });
      },
      async editItem(){ 
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append("name", this.name);
      formData.append("phone", this.phone);
        formData.append("location", this.location);
        formData.append("category", this.category);
        formData.append('bio',this.bio);

        // let categoryIds = '';
        // if (this.category) {
        //   for (let i = 0; i < this.category.length; i++) {
        //     categoryIds += this.category[i].id;
        //     if (i < this.category.length - 1) {
        //       categoryIds += ',';
        //     }
        //   }
        // }
        // formData.append("category", categoryIds);
      let url = "/updatedoctorspecialty";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchDoctorspecialty();
          // this.fetchSpecialisation();
          this.$bvModal.hide('edit-item');
          this.category="";
          this.name="";
          this.phone="";
          this.location="";
         
          this.bio='';
        }
      });
      },
      async removeItem() { 
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/removedoctorspecialty";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchDoctorspecialty();
          // this.fetchSpecialisation();
          this.$bvModal.hide('delete-item');
        }
      });
      },
    },
  };
  </script>